import {
  propertyStatusConfigurationDossier,
  propertyStatusConfigurationReservation,
  reglesConfigurationFormation,
  reglesConfigurationReservation,
  getNaturesFichiersCxpi as getNaturesFichiers,
} from '@/features/domaine/regles-akto/CXPI'
import {
  cxpiFormationDemandeServices,
  cxpiDrfDemandeServices,
  cxpiDrfDossierServices,
} from '@/features/services/demande'
import { buildDemandeStore } from '../shared'
import type { LovCxpiDTO } from '@/features/api/extranet/dto/Demande/CXPI'

export const useFormationDemandeCXPIStore = buildDemandeStore<'MODEL_CXPI', LovCxpiDTO>({
  model: 'MODEL_CXPI',
  typeDemande: 'Formation',
  module: 'demande',
  demandeService: cxpiFormationDemandeServices,
  propertyStatusConfiguration: propertyStatusConfigurationDossier,
  reglesConfiguration: reglesConfigurationFormation,
  getNaturesFichiers,
})

export const useReservationDemandeCXPIStore = buildDemandeStore<'MODEL_CXPI', LovCxpiDTO>({
  model: 'MODEL_CXPI',
  typeDemande: 'ReservationFonds',
  module: 'demande',
  demandeService: cxpiDrfDemandeServices,
  propertyStatusConfiguration: propertyStatusConfigurationReservation,
  reglesConfiguration: reglesConfigurationReservation,
  getNaturesFichiers,
})

export const useReservationDossierCXPIStore = buildDemandeStore<'MODEL_CXPI', LovCxpiDTO>({
  model: 'MODEL_CXPI',
  typeDemande: 'ReservationFonds',
  module: 'dossier',
  demandeService: cxpiDrfDossierServices,
  propertyStatusConfiguration: {},
  reglesConfiguration: {},
  getNaturesFichiers,
})
